
import $ from "jquery"
import Waypoint from "plugins/waypoint"


const $navbar = $(".page--single-listings-detail-page--main-section__main__section--navbar")
const $list_items = $navbar.find(".navbar-item-list li")
const $side_menu = $(".page--single-listings-detail-page--main-section__side--main")
const $navbar_box = $(".page--single-listings-detail-page--main-section__main__section--navbar--background")

// check whether this listing is commercial or not
const is_commercial = $("body").hasClass("page-property-type-is-commercial")

let click_flag = false

const init = (): void => {
  initializeStickyNavbar()
  initializeScrollspyNavbar()
}

// Maybe this can be extracted later,
// or remain as page specific code
//
// Not sure `js-fixed` can be renamed
function initializeStickyNavbar() {

  const $window = $(window)

  const target_offset = $(".page--single-listings-detail-page--main-section__main__section-address-heading").offset()?.top || 0

  $(window).scroll(() => {

    if ( ($window.scrollTop() || 0) > target_offset &&  ($window.scrollTop() || 0) < parseFloat($(".main-container").css("height"))) {
      if (!is_commercial) {
        $side_menu.addClass("show-navbar")
      }

      if (!$navbar.hasClass("js-fixed")) {
        $navbar.addClass("js-fixed")

        $navbar.css("position", "fixed")
        $navbar.css("top", 0)

        $navbar_box.css("position", "fixed")
        $navbar_box.css("top", 0)

        // Extra Animation
        $navbar.hide()
        $navbar.slideDown()

        $navbar_box.hide()
        $navbar_box.slideDown()
      }
    }
    else {
      if (!is_commercial) {
        $side_menu.removeClass("show-navbar")
      }

      if (click_flag) {
        const carousel_offset = $(".page--single-listings-detail-page--main-section__main__carousel").offset()?.top || 0

        if ($navbar.hasClass("js-fixed") &&  ($window.scrollTop() || 0) < carousel_offset) {
          $navbar.removeClass("js-fixed")

          $navbar_box.slideUp({easing: "linear"})
          $navbar.slideUp({easing: "linear"})
        }
      }
      else {
        if ($navbar.hasClass("js-fixed")) {
          $navbar.removeClass("js-fixed")

          $navbar_box.slideUp({easing: "linear"})
          $navbar.slideUp({easing: "linear"})
        }
      }

      click_flag = false
    }
  })
}

function initializeScrollspyNavbar() {
  let previous = ""

  $list_items.find("> a").each((_idx, el) => {
    const $this = $(el)

    const $target = $($this.attr("href") as string)

    if ($target.offset() != null) {
      $(el).parent("li").css("display","block")

      const current = (el.attributes.getNamedItem("href")?.textContent) as string
      if (previous !== "") {
        create_waypoint_object(current, previous, 25)
      }

      previous = current

      $(el).on("click", () => {
        $("html, body").animate({
          scrollTop: Math.floor($target.offset()?.top || 0) - 64,
        }, 500);

        // special case handling for clicking navbar item to visit corresponding section within same page
        click_flag = true
      })
    }
  })
}

function create_waypoint_object(current_element: string, previous_element: string, offset_precentage_number: number){
  new Waypoint({
    element: document.querySelector(current_element) as HTMLElement,
    handler:    (direction: string) => {
      $list_items.removeClass("active")
      if (direction === "down") {
        // enter current section
        $list_items.find("> a").each((_idx, el) => {
          if (el.attributes.getNamedItem("href")?.textContent === current_element) {
            $(el).parent("li").addClass("active")
          }
        })
      }
      else {
        // leave current section
        $list_items.find("> a").each((_idx, el) => {
          if (el.attributes.getNamedItem("href")?.textContent === previous_element) {
            $(el).parent("li").addClass("active")
          }
        })
      }
    },
    offset: offset_precentage_number.toString() + "%",
  });
}


export default {
  init: init,
}
